var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversityGeneralAcceptancerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.987,
    height: 41,
    viewBox: "0 0 40.987 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "done",
    transform: "translate(-1.982 -1.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55216",
    "data-name": "Path 55216",
    d: "M20.549,8.89A11.659,11.659,0,1,0,32.208,20.549,11.659,11.659,0,0,0,20.549,8.89Zm0,15.242a1.51,1.51,0,0,1-2.073,0L14.393,20.05l2.086-2.06,3.046,3.046,5.119-5.119,2.035,2.073Z",
    transform: "translate(1.933 1.933)",
    fill: "#387f75",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55217",
    "data-name": "Path 55217",
    d: "M42,19.269c-1.28-1.868-2.56-3.839-2.56-3.839s-.448-2.291-.9-4.466A5.8,5.8,0,0,0,34,6.42L29.52,5.5l-3.839-2.56a5.823,5.823,0,0,0-6.4,0L15.443,5.5l-4.479.921A5.8,5.8,0,0,0,6.42,10.964c-.448,2.188-.921,4.492-.921,4.492s-1.28,1.971-2.56,3.839a5.823,5.823,0,0,0,0,6.4c1.28,1.868,2.56,3.839,2.56,3.839s.461,2.3.921,4.492a5.8,5.8,0,0,0,4.543,4.518l4.492.921,3.839,2.56a5.823,5.823,0,0,0,6.4,0l3.839-2.56L34,38.543A5.8,5.8,0,0,0,38.543,34c.448-2.188.921-4.492.921-4.492s1.28-1.971,2.56-3.839a5.823,5.823,0,0,0-.026-6.4ZM22.482,37.058A14.577,14.577,0,1,1,37.058,22.482,14.577,14.577,0,0,1,22.482,37.058Z",
    transform: "translate(0 0)",
    fill: "#63c5b7",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneralAcceptancerate);
export default __webpack_public_path__ + "static/media/university-general-acceptancerate.db54d4d6db32ad7e9e88dcc911c1afab.svg";
export { ForwardRef as ReactComponent };